/* ==========================================================================
   Design System
   Variables
   ========================================================================== */
/* ==========================================================================
   Design System
   Breakpoint variables.

   NOTE: If any of the values in this file are adjusted,
         they need to be adjusted in vars-breakpoints.js as well.
   ========================================================================== */
/* ==========================================================================
   Design System
   Grid mixins
   ========================================================================== */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* ==========================================================================
   Design System
   Media queries
   ========================================================================== */
/* ==========================================================================
   Design System
   Base styles
   ========================================================================== */
/* ==========================================================================
   Design System
   Expandable Group Styling
   ========================================================================== */
.o-expandable-group .o-expandable {
  border-bottom: 1px solid var(--gray-40);
}
.o-expandable-group .o-expandable:first-child {
  border-top: 1px solid var(--gray-40);
}
@media print {
  .o-expandable__header[aria-expanded=true] .o-expandable__cue-close, .o-expandable__header[aria-expanded=false] .o-expandable__cue-open {
    display: none;
  }
  .o-expandable__content[aria-expanded=false] {
    display: block;
    max-height: 99999px !important;
  }
}
.o-expandable .print__header[aria-expanded=true] .o-expandable .print__cue-close, .o-expandable .print__header[aria-expanded=false] .o-expandable .print__cue-open {
  display: none;
}
.o-expandable .print__content[aria-expanded=false] {
  display: block;
  max-height: 99999px !important;
}